import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { LocationAndStyleStep } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/location-and-style-step/location-and-style-step';
import { getParamsWithMakes } from 'client/utils/router-params';
import { AppraiserContainerPrefetch } from './appraiser-container';
import { getPageDefinitionConfiguration } from './appraiser-definition-config';

export default pageDefinition({
  ...getPageDefinitionConfiguration(),
  component: props => (
    <AppraiserContainerPrefetch
      params={getParamsWithMakes(props)}
      {...props}
      LocationAndStyleStepComponent={LocationAndStyleStep}
    />
  ),
});
